import {TextSize} from 'platform/foundation';

/** Above this the circle is a podium one, and small initials look lost in it. */
const COMPACT_CIRCLE_MAX_SIZE = 8;

/** Keeps initials in proportion to their circle, matching platform Avatar's own steps. */
export function getSalesLeagueInitialsTextSize(size: number): TextSize {
  return size <= COMPACT_CIRCLE_MAX_SIZE ? 'xSmall' : 'base';
}
